// =============================================================================
// features/configuracoes/comercial/OutcomeRow.tsx — Linha de um desfecho
// comercial editável (doc 26 §6.9: "habilitar/desabilitar, rótulo, e quais
// exigem observação, retorno ou bloqueio").
// =============================================================================

import type { SalesOutcomeConfig } from '@elemento/shared-schemas';
import * as React from 'react';

import { Input } from '../../../components/ui/Input';

import { Toggle } from './Toggle';

interface OutcomeRowProps {
  item: SalesOutcomeConfig;
  onChange: (next: SalesOutcomeConfig) => void;
  disabled?: boolean;
}

export function OutcomeRow({
  item,
  onChange,
  disabled = false,
}: OutcomeRowProps): React.JSX.Element {
  return (
    <tr
      className="transition-colors duration-fast"
      style={{ borderBottom: '1px solid var(--border-subtle)' }}
    >
      <td className="px-4 py-3 align-top">
        <Toggle
          id={`outcome-${item.code}-enabled`}
          checked={item.enabled}
          onChange={(enabled) => onChange({ ...item, enabled })}
          label=""
          disabled={disabled}
        />
      </td>
      <td className="px-4 py-3 align-top">
        <span className="font-mono text-ink-3" style={{ fontSize: 'var(--text-xs)' }}>
          {item.code}
        </span>
      </td>
      <td className="px-4 py-3 align-top min-w-[180px]">
        <Input
          id={`outcome-${item.code}-label`}
          label=""
          aria-label={`Rótulo do desfecho ${item.code}`}
          value={item.label}
          disabled={disabled || !item.enabled}
          onChange={(e) => onChange({ ...item, label: e.target.value })}
        />
      </td>
      <td className="px-4 py-3 align-top">
        <Toggle
          id={`outcome-${item.code}-note`}
          checked={item.requiresNote}
          onChange={(requiresNote) => onChange({ ...item, requiresNote })}
          label="Observação"
          disabled={disabled || !item.enabled}
        />
      </td>
      <td className="px-4 py-3 align-top">
        <Toggle
          id={`outcome-${item.code}-appointment`}
          checked={item.requiresAppointment}
          onChange={(requiresAppointment) => onChange({ ...item, requiresAppointment })}
          label="Retorno"
          disabled={disabled || !item.enabled}
        />
      </td>
      <td className="px-4 py-3 align-top">
        <Toggle
          id={`outcome-${item.code}-blocks`}
          checked={item.blocksContact}
          onChange={(blocksContact) => onChange({ ...item, blocksContact })}
          label="Bloqueio"
          disabled={disabled || !item.enabled}
        />
      </td>
    </tr>
  );
}
